import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  ContentBullet,
  Block,
} from 'components/landing/components';

import SectionBlock from './SectionBlock';
import TalkButton from './TalkButton';

const dumbServices = dumbBem('l-services');
const ContentBlocksWrp = tx([{ element: 'content-blocks-wrapper' }, dumbServices])('div');
const ContentBlocks = tx([{ element: 'content-blocks' }, dumbServices])('div');

const Sections = ({
  section,
  blockRefs,
  scrollToDemoForm,
}) => {
  return (
    <Block
      __ref={blockRefs[section.ref]}
      modifier="content"
    >
      <ContentBullet
        title={section.title}
        description={section.description}
      />

      <ContentBlocksWrp>
        <ContentBlocks>
          {section.blocks.map(block => (
            <SectionBlock
              key={block.title}
              block={block}
              sectionModifier={section.modifier}
            />
          ))}
        </ContentBlocks>

        {section.talkButton && (
          <TalkButton scrollToDemoForm={scrollToDemoForm} />
        )}
      </ContentBlocksWrp>
    </Block>
  );
};

Sections.propTypes = {
  section: PropTypes.shape({
    ref: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  blockRefs: PropTypes.object.isRequired,
  scrollToDemoForm: PropTypes.func.isRequired,
};

export default Sections;



// WEBPACK FOOTER //
// ./src/components/landing/pages/services/Section.jsx